import React from 'react';

interface OwnProps {
    value?: string;
    modifierClass?: string;
    name: string;
    label?: string;
    required?: boolean;
    invalid?: boolean;
    notice?: string;
    onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    disabled?: boolean;
}

type Props = OwnProps;

class FormSelect extends React.Component<Props, {}> {
    private select = React.createRef<HTMLSelectElement>();

    public focus = () => {
        this.select.current!.focus();
    }

    private handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        e.persist();

        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    public render() {
        return <div className="form__section__inner">
            <div className={"form__field form__field--select " + (this.props.modifierClass || '') + (this.props.required ? ' is-required' : '') + (this.props.invalid ? ' is-invalid' : '') + (this.props.disabled ? ' is-disabled' : '')}>
                <div className="form__container">
                    {this.props.label &&
                        <label htmlFor={this.props.name} className="form__label">
                            <span className="form__label__text">{this.props.label}{this.props.required && <React.Fragment>&nbsp;&nbsp;<strong>&#10033;</strong></React.Fragment>}</span>
                        </label>
                    }
                    <select name={this.props.name} value={this.props.value} className="form__item" onChange={this.handleChange} ref={this.select} disabled={this.props.disabled}>
                        {this.props.children}
                    </select>
                </div>
                {this.props.notice &&
                    <span className="form__notice">{this.props.notice}</span>
                }
            </div>
        </div>;
    }
}

export default FormSelect;